import React from 'react';
import {
	TOOL_NONE,
	TOOL_ZOOM_IN,
	TOOL_ZOOM_OUT,
	ToolbarButton,
	IconCursor,
	IconFit,
	IconZoomIn,
	IconZoomOut,
} from 'react-svg-pan-zoom';

const ToolbarItems = (props) => {
	const { activeToolColor, tool, position, handleFit, handleChangeTool } = props;

	return (
		<div>
			<ToolbarButton
				toolbarPosition={position}
				active={tool === TOOL_NONE}
				activeColor={activeToolColor}
				name='unselect-tools'
				title='Selection'
				onClick={(event) => handleChangeTool(event, TOOL_NONE)}
			>
				<IconCursor />
			</ToolbarButton>

			<ToolbarButton
				toolbarPosition={position}
				active={tool === TOOL_ZOOM_IN}
				activeColor={activeToolColor}
				name='select-tool-zoom-in'
				title='Zoom in'
				onClick={(event) => handleChangeTool(event, TOOL_ZOOM_IN)}
			>
				<IconZoomIn />
			</ToolbarButton>

			<ToolbarButton
				toolbarPosition={position}
				active={tool === TOOL_ZOOM_OUT}
				activeColor={activeToolColor}
				name='select-tool-zoom-out'
				title='Zoom out'
				onClick={(event) => handleChangeTool(event, TOOL_ZOOM_OUT)}
			>
				<IconZoomOut />
			</ToolbarButton>

			<ToolbarButton
				toolbarPosition={position}
				active={false}
				activeColor={activeToolColor}
				name='fit-to-viewer'
				title='Fit to viewer'
				onClick={(event) => handleFit(event)}
			>
				<IconFit />
			</ToolbarButton>
		</div>
	);
};

export default ToolbarItems;
